import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { amphoraIntegrationQuery } from "modules/settings/lib/amphora/amphoraIntegrationQuery"

export function useDeleteAmphoraIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      await axios.delete("/integrations/amphora")
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: amphoraIntegrationQuery().queryKey })
    },
  })
}
